<template>
    <div class="footer-big" :class="{'footer-bot' : $route.meta.fix}">
        <div class="row justify-content-between align-items-center way-footer">
            <div class="col-xl-3 col-12 way-footer-logo">
                <img src="https://static.cleanlive.cn/site/img/logo.png" alt="">
            </div>
            <div class="col-xl-7 col-12 way-footer-con">
                <ul class="way-footer-link">
                    <li>
                        <router-link to="/aboutus">关于我们</router-link>
                    </li>
                    <li>|</li>
                    <li>
                        <router-link to="/opinion">意见反馈</router-link>
                    </li>
                    <li>|</li>
                    <li>
                        <router-link to="/agreement">服务协议</router-link>
                    </li>
                    <li>|</li>
                    <li>
                        <a href="https://en.waypal.com" target="_black">Teacher Recruitment</a>
                    </li>
                </ul>
                <div class="way-footer-address">
                    <p>客服热线：010 - 68405918</p>
                    <p>中心地址：北京市海淀区西三环北路19号北外国际大厦7层729室</p>
                </div>
                <div class="way-footer-icp">
                    2018 &#169 Waypal.com | 北京拾玖号教育科技有限公司 | 京ICP备17063932号
                </div>
                <div class="way-footer-badge">
                  <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802027314" target="_blank"> <span><img src="https://static.cleanlive.cn/site/img/police-badge.png" alt=""></span> 京公网安备 11010802027314号</a>
                </div>
            </div>
            <div class="col-xl-2 way-footer-qr">
                <img src="https://static.cleanlive.cn/site/img/qr.jpeg" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Footer',
};
</script>

<style lang="less" scoped>
@import "../assets/css/reset.less";
.footer-bot {
  padding: 2.5rem 1rem 7rem !important;
}
.footer-big {
  width: 100%;
  background: #fff;
  padding: 2.5rem 1rem;
  box-shadow: 0px -4px 6px 0px rgba(0,0,0,0.05);
  .way-footer {
    max-width: 1200px;
    margin: 0 auto;
    .way-footer-logo {
      max-width: 222px;
      text-align: left;
    }
    .way-footer-link {
      width: 67%;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-family: 'Microsoft YaHei';
      li a {
        color: rgba(108, 108, 108, 1);
      }
    }
    .way-footer-address {
      width: 100%;
      text-align: left;
      font-size: 14px;
      font-family: 'Microsoft YaHei';
      color: rgba(108, 108, 108, 1);
      margin-top: 33px;
      margin-bottom: 10px;
    }
    .way-footer-icp {
      width: 100%;
      text-align: left;
      font-size: 14px;
      font-family: 'Microsoft YaHei';
      color: rgba(108, 108, 108, 1);
    }
    .way-footer-badge {
      text-align: left;
      font-size: 14px;
      font-family: 'Microsoft YaHei';
      margin-top: 1rem;
      a {
        color: rgba(108, 108, 108, 1);
        img {
          width: 20px;
        }
      }
    }
    .way-footer-qr {
      max-width: 142px;
      height: 142px;
      background: rgba(255, 195, 75, 1);
      border-radius: 4px;
      padding: 7px;
      box-sizing: border-box;
    }
  }
}
@media screen and (max-width: 414px) {
  .footer-big .way-footer .way-footer-link {
    width: 100%;
  }
  .way-footer-con {
    margin: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wayFooter.vue